// NPM Imports
import { batch } from "react-redux";

// Components Imports
// import { Toastr } from "@revvsales/components";

// Internal Imports
import { UNDO_REDO_STACK_LIMIT } from "../../constants/document";
import store from "../../store";
import { removeDataFromLocalStorage } from "../../utils/globalUtils";

import {
  analyzeDocService,
  approvalStatusCheckService,
  approveRejectDocService,
  changeDocumentStatusService,
  createNewDocument,
  editApprovedDocumentService,
  fetchAllDocumentTypes,
  fetchClausesForDealTable,
  fetchDynamicFieldsService,
  forceApproveDocService,
  getAccountAssetsService,
  getDocActivities,
  resetDocToDraftService,
  sendDocForApprovalService,
  updateDocumentDetails,
  updateSubmitDeclineInternalService,
  updateDocumentComponentService,
  batchUpdateDocumentSection,
  uploadDocument,
  updateDocDetailsService,
  sendDocumentForSignature,
  sendDocumentForSignatureV2,
  cancleESignatureService,
  updateDocumentStatusService,
  updateDocumentTagService,
  addDocRecipientsService,
  fetchDocRecipientListService,
  docAccepAndSignService,
  docAfterAccepAndSignService,
  deleteReviewersServices,
  editReviewerPermissionServices,
  addAcceptorsService,
  acceptanceApprovalStatusCheckService,
  deleteDocumentComponentService,
  restoreDocumentComponentService,
  generatePermaLinkService,
  generateSnapLinkService,
  getPermaLinkService,
  getSnapLinkService,
  deletePermaLinkService,
  deleteSnapLinkService,
  updateDocumentField,
  updateDocumentFieldNonLoggedIn,
  updateSubmitRejectSignerFiller,
  updateDocSignatories,
  deleteDocSigner,
  authStripe,
  sendStripePaymentOnSave,
  getStripePaymentSessionId,
  getStripeUser,
  getStripePaymentDetails,
  deactivateStripe,
  getStripePaymentDetailsWithHash,
  getStripePaymentDetailsWithHashPerma,
  deleteStripeFromDocument,
  updateDocumentOrder,
} from "./services";

import {
  restoreTemplateComponentService,
  deleteTemplateComponentService,
  updateTemplateComponentService,
  updateTemplateOrder,
} from "../DocumentTemplateActions/templateService";

import {
  prepareDocAnalysisData,
  prepareDocApprovalStatusData,
  prepareCollaboratorsData,
  removeEntityFromSection,
  validateDocForm,
} from "./method";
import { generateDocStatusConfigs } from "../QuotationActions/QuotationMethods";
import { fetchDocumentByDocNo } from "../QuotationActions/QuotationServices";
// import { updateToolpaneView } from "../ToolbarActions/toolbarActions";

import { QuotationUtils, GlobalUtils, DocumentUtils } from "../../utils";
import { DOCUMENTS, COMMON } from "../../constants";

const { DOCUMENT_MODE, DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
const { createDocumentRevision, fillFormField } = QuotationUtils;
const { numberForamting, writeDataToLocalStorage } = GlobalUtils;
const { getContentForComponent, convertDocumentContent } = DocumentUtils;

const { DEFAULT_CURRENCY, CURRENCY_SYMBOL } = COMMON;

export const restoreSection = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return restoreDocumentComponentService;
  if (mode === DOCUMENT_MODE.TEMPLATE) return restoreTemplateComponentService;
  return () => {};
};

export const deleteSection = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return deleteDocumentComponentService;
  if (mode === DOCUMENT_MODE.TEMPLATE) return deleteTemplateComponentService;
  return () => {};
};

export const updateSection = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return updateDocumentComponentService;
  if (mode === DOCUMENT_MODE.TEMPLATE) return updateTemplateComponentService;
  return () => {};
};

export const updateComponentOrder = mode => {
  if (mode === DOCUMENT_MODE.DOCUMENT) return updateDocumentOrder;
  if (mode === DOCUMENT_MODE.TEMPLATE) return updateTemplateOrder;
  return () => {};
};

// upload a document to s3
export const saveDocument = (file, opp) =>
  uploadDocument(file, opp)
    .then(res => res)
    .catch(error => error);

// create a document using the uploaded uri and document id
export const createDocument = document =>
  createNewDocument(document)
    .then(res => res)
    .catch(error => error);

// create document and content
export const createDocumentAndContent = document =>
  new Promise((resolve, reject) => {
    createNewDocument(document)
      .then(res => resolve(res))
      .catch(error => reject(error));
  });

// below action uses fetchDocumentByDocNo with a param - (no_content is true)
// and sends back the doc object without document/dealtable data. We'll use this to pick out
// status, isLocked and other meta data (as required) fields value and update redux
export const fetchAndUpdateDocMeta = docNo => dispatch =>
  new Promise((resolve, reject) => {
    fetchDocumentByDocNo(docNo, true)
      .then(response => {
        const {
          id: docID,
          status: docStatus,
          is_locked: docIsLocked,
          stage,
          revision_no: revisionNo,
        } = response;
        const docStatusConfigs = generateDocStatusConfigs(docStatus, stage);

        dispatch({
          type: "UPDATE_DOC_META",
          payload: {
            docID,
            docStatus,
            docIsLocked,
            docStatusConfigs,
            stage,
            revisionNo,
          },
        });

        resolve("success");
      })
      .catch(error => {
        reject(error);
      });
  });

export const tempUpdateDocMeta = payload => dispatch => {
  const { docIsLocked, stage } = payload;

  dispatch({
    type: "TEMP_UPDATE_DOC_META",
    payload: {
      docIsLocked,
      stage,
    },
  });
};

export const getClausesForDealTable = dealTableID => async dispatch => {
  try {
    const clauses = await fetchClausesForDealTable(dealTableID);
    dispatch({
      type: "UPDATE_CLAUSE_INFORMATION",
      payload: clauses,
    });
    return clauses;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveDocumentSection = () =>
  updateDocumentDetails()
    .then(res => res)
    .catch(error => error);

export const getAllDocumentTypes = () => dispatch => {
  fetchAllDocumentTypes()
    .then(documentType => {
      dispatch({
        type: "UPDATE_DOCUMENT_TYPES",
        payload: documentType,
      });
    })
    .catch(error => error);
};

export const nukeDocApprovalsData = () => dispatch => {
  dispatch({
    type: "NUKE_DOCUMENT_APPROVALS_DATA",
  });
};

export const batchUpdateSectionInDocument = sections => dispatch => {
  dispatch({
    type: "BATCH_UPDATE_SECTION_IN_DOCUMENT",
    payload: sections,
  });
};
/* 
Assets Library Action below
*/

export const getAccountAssets = accountID => dispatch =>
  new Promise((resolve, reject) => {
    getAccountAssetsService(accountID)
      .then(response => {
        dispatch({
          type: "ACCOUNT_ASSETS",
          payload: response.Assets,
        });
        resolve("success");
      })
      .catch(error => {
        reject(error);
      });
  });

/* 
  Assets Library Action above
*/

/**
 * ToolsPane Action below
 */

export const changeToolsView = view => dispatch => {
  dispatch({
    type: "UPDATE_TOOLPANE_DATA",
    payload: {
      isOpen: true,
      view,
    },
  });
};

/**
 * ToolsPane Action above
 */

/**
 * DocApproval/WorkFlow Action below
 */

export const analyzeDoc = payload => dispatch =>
  new Promise((resolve, reject) => {
    analyzeDocService(payload)
      .then(response => {
        dispatch({
          type: "DOC_ANALYSIS",
          payload: prepareDocAnalysisData(response.Analysis),
        });
        resolve(response);
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const resetDocAnalysisData = () => dispatch => {
  dispatch({
    type: "DOC_RESET_ANALYSIS",
    payload: [],
  });
};

export const sendDocForApproval = payload => () =>
  new Promise((resolve, reject) => {
    sendDocForApprovalService(payload)
      .then(response => {
        console.debug(response);
        resolve("success");
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const approvalStatusCheck = (docID, status) => dispatch =>
  new Promise((resolve, reject) => {
    approvalStatusCheckService(docID, status)
      .then(response => {
        const {
          approvalStatusData,
          pendingApprovers,
          docAllApprovers,
        } = prepareDocApprovalStatusData(response.Approvals);
        const payload = {
          approvalStatusData,
          pendingApprovers,
          docAllApprovers,
          collaboratorsData: prepareCollaboratorsData(response.Approvals),
          pendingApprovalRequired: response.Response_Required,
        };
        dispatch({
          type: "DOC_APPROVAL_STATUS",
          payload,
        });
        resolve("success");
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const approveRejectDoc = (docID, payload, isApproved) => () =>
  new Promise((resolve, reject) => {
    approveRejectDocService(docID, payload, isApproved)
      .then(() => {
        resolve("success");
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const resetDocToDraft = docID => () =>
  new Promise((resolve, reject) => {
    resetDocToDraftService(docID)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const forceApproveDoc = docID => () =>
  new Promise((resolve, reject) => {
    forceApproveDocService(docID)
      .then(() => {
        resolve("success");
      })
      .catch(error => {
        reject(error);
      });
  });

export const documentStatus = (docID, changedStatus) => () =>
  new Promise((resolve, reject) => {
    changeDocumentStatusService(docID, changedStatus)
      .then(() => {
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

/**
 * DocApproval/WorkFlow Action above
 */

// Store deal table meta information in a store
// export const dealTableInformation = dealTableInfo => dispatch =>
//   new Promise((resolve, reject) => {
//     try {
//       dispatch([
//         {
//           type: "UPDATE_DEAL_TABLE_GROUP_INFORMATION",
//           payload: dealTableInfo,
//         },
//       ]);
//       resolve("success");
//     } catch (error) {
//       reject(error);
//     }
//   });

export const updateHoveredDocumentSectionId = (
  sectionID,
  updateAfterSection,
) => dispatch => {
  // const sectionID = sectionData ? sectionData.id : null;
  // Don't for HTML components as that is handled in updateHoveredDocumentSectionId
  // if (
  //   sectionData &&
  //   sectionData.type !== "HTML" &&
  //   sectionData.type !== "DealTable"
  // ) {
  //   store.dispatch(updateToolpaneView(sectionData, "DOCUMENT"));
  // }
  dispatch({
    type: "UPDATE_HOVERED_DOCUMENT_SECTION_ID",
    payload: { sectionID, updateAfterSection },
  });
};

export const makeSendForSignatureButton = data => dispatch => {
  const { status, stage } = data;
  const docStatusConfigs = generateDocStatusConfigs(status, stage);
  const payload = {
    docStatusConfigs,
    status,
    stage,
  };
  dispatch({
    type: "UPDATE_SEND_FOR_SIGNATURE_BUTTON_STATUS",
    payload,
  });
};

export const sendForSignatureV2 = docId => dispatch =>
  new Promise((resolve, reject) => {
    sendDocumentForSignatureV2(docId)
      .then(response => {
        dispatch({
          type: "TOGGLE_IFRAME_VIEW",
          payload: {
            iframeUrl: "",
            envelopeID: "",
            stage: "SENT",
            // isLocked: true,
            isSentForSignature: false,
          },
        });
        resolve(response);
      })
      .catch(error => {
        console.error(
          "documentActions => sendForSignatureV2 => error :",
          error,
        );
        reject(error);
      });
  });

export const addDocRecipientsAction = (docId, data, flag) => dispatch =>
  new Promise((resolve, reject) => {
    // for the new fillers part
    const {
      document: { showForm },
    } = store.getState().DocumentStore;
    let newData = data;
    if (showForm) {
      newData = { ...newData, fillers: data.fillers };
    } else if (newData.fillers) {
      delete newData.fillers;
    }
    addDocRecipientsService(docId, newData)
      .then(response => {
        let docRecipients = [];
        const { collaborators, signers } = response;
        if (
          (collaborators && collaborators.length > 0) ||
          (signers && signers.length > 0)
        ) {
          docRecipients = [...collaborators, ...signers];
        }
        const {
          document: { stage },
        } = store.getState().DocumentStore;
        let tempStage = stage;
        // let showSignIframe = false;
        let isSentForSignature = false;
        // if (response.signers && response.signers.length > 0) {
        //   store.dispatch(sendForSignatureV2(docId));
        //   // isSentForSignature = false;
        //   showSignIframe = false;
        //   // stage = "SENT";
        // } else {
        //   stage = "SENT";
        // }
        if (
          flag === "isSigner" &&
          response.signers &&
          response.signers.length > 0
        ) {
          isSentForSignature = true;
          if (showForm && data.fillers && data.fillers.length) {
            tempStage = "SENT_FOR_FILLING";
          } else {
            tempStage = "SENT";
          }

          // showSignIframe = false;
        }
        const payload = {
          // iframeUrl: response.tagging_view_url || "",
          // iframeUrl: "",
          // envelopeID: response.envelopeId,
          envelopeID: "",
          stage: tempStage,
          isSentForSignature,
          docRecipients,
          // showSignIframe,
        };

        dispatch({
          type: "UPDATE_DOC_STAGE_AFTER_ADD_RECIPIENTS",
          payload,
        });

        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
export const addAcceptorsDetailsAction = (docId, data) => dispatch =>
  new Promise((resolve, reject) => {
    addAcceptorsService(docId, data)
      .then(res => {
        let docRecipients = [];
        let docApprovalPending = "";
        const {
          document: { stage },
        } = store.getState().DocumentStore;
        let tempStage = stage;
        if (res && res.length > 0) {
          docRecipients = [...res];
          docApprovalPending = res.is_acceptor;
          tempStage = "SENT";
        }
        const payload = {
          docRecipients,
          docId,
          docApprovalPending,
          stage: tempStage,
        };
        dispatch({
          type: "ADD_ACCEPTORS",
          payload,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const fetchDocRecipientListAction = docId => dispatch =>
  new Promise((resolve, reject) => {
    fetchDocRecipientListService(docId)
      .then(response => {
        let data = [];
        let acceptData = [];
        if (response) {
          const { collaborators, signers, acceptors } = response;
          if (
            (collaborators && collaborators.length > 0) ||
            (signers && signers.length > 0) ||
            (acceptors && acceptors.length > 0)
          ) {
            data = [...collaborators, ...signers, ...acceptors];
          }
          if (acceptors && acceptors.length > 0) {
            acceptData = [...acceptors];
          }
        }
        dispatch({
          type: "FETCH_DOC_RECIPIENT_LIST",
          payload: { data, acceptData },
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const removeQuotetableData = () => dispatch => {
  dispatch({
    type: "NUKE_QUOTETABLE_DATA",
  });
};

export const removeGoogleSheetData = sectionID => dispatch => {
  dispatch({
    type: "REMOVE_GOOGLESHEET_DATA",
    payload: sectionID,
  });
};

export const addComponentInDocument = (
  newSectionList,
  newSection,
  headerFooterType,
) => dispatch => {
  dispatch({
    type: "ADD_COMPONENT_IN_DOCUMENT",
    payload: {
      newSectionList,
      newSection,
      headerFooterType,
    },
  });
  /**
   * Need to update the newly added section data in ToolpaneStore to get the "sectionDataForSignature"
   * in "<SignatureList />" component only for Signature section
   */
  if (newSection && newSection.type === "Signature") {
    dispatch({
      type: "UPDATE_TOOLPANE_DATA_FOR_SIGNATURE",
      payload: {
        sectionData: newSection,
      },
    });
  }
};

// New method
export const addDocumentComponentAction = (
  layout,
  newComponent,
  dbRowIndex,
  dbColIndex,
  headerFooterType,
  shouldNotActivateComponent,
) => dispatch => {
  dispatch({
    type: "ADD_DOCUMENT_COMPONENT",
    payload: {
      layout,
      newComponent,
      headerFooterType,
      dbRowIndex,
      dbColIndex,
      shouldNotActivateComponent,
    },
  });
  /**
   * Need to update the newly added section data in ToolpaneStore to get the "sectionDataForSignature"
   * in "<SignatureList />" component only for Signature section
   */
  if (newComponent && newComponent.type === "Signature") {
    dispatch({
      type: "UPDATE_TOOLPANE_DATA_FOR_SIGNATURE",
      payload: {
        sectionData: newComponent,
      },
    });
  } else if (newComponent && newComponent.type === "StripePayment") {
    dispatch({
      type: "UPDATE_TOOLPANE_DATA_FOR_STRIPE_PAYMENT",
      payload: {
        sectionData: newComponent,
      },
    });
  }
};

export const deleteDocumentComponentAction = componentID => dispatch => {
  const { components } = store.getState().DocumentStore;
  const { dealTableId } = store.getState().QuotationStore;
  let isDealtableComponent = false;
  let isGoogleSheetComponent = false;
  const component = components[componentID] && components[componentID].content;
  if (
    (component && component.type === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE) ||
    (component && component.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE)
  ) {
    isDealtableComponent = true;
  } else if (
    component &&
    component.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET
  ) {
    isGoogleSheetComponent = true;
  }
  if (isDealtableComponent && dealTableId)
    store.dispatch(removeQuotetableData());
  if (isGoogleSheetComponent)
    store.dispatch(removeGoogleSheetData(componentID));
  dispatch({
    type: "DELETE_DOCUMENT_COMPONENT",
    payload: componentID,
  });
};

export const updateComponentsDBRowColIndexesAction = newComponents => dispatch => {
  dispatch({
    type: "UPDATE_COMPONENTS_DB_ROW_COL_INDEXES",
    payload: { newComponents },
  });
};

export const updateDocumentComponentAction = (
  component,
  newlyAddedComponent, // It is being used for adding components in coverpage & header/footer
) => dispatch => {
  dispatch({
    type: "UPDATE_DOCUMENT_COMPONENT",
    payload: { component, newlyAddedComponent },
  });
};

export const toggleComponentLockUnlock = data => dispatch => {
  const { DocumentStore } = store.getState();
  const { components } = DocumentStore;

  let newComponent = null;
  if (data) {
    if (data.isBodyView) {
      if (components[data.activeComponentID]) {
        newComponent = {
          ...components[data.activeComponentID].content,
          lock: data.lockStatus,
        };
      }
    } else if (data.isCoverPageView) {
      let coverpage = null;
      if (components[data.coverPageComponentId]) {
        coverpage = { ...components[data.coverPageComponentId] };
      }
      if (coverpage) {
        coverpage = {
          ...coverpage.content,
          data: {
            ...coverpage.content.data,
            components: {
              ...coverpage.content.data.components,
              [data.activeComponentID]: {
                ...coverpage.content.data.components[data.activeComponentID],
                content: {
                  ...coverpage.content.data.components[data.activeComponentID]
                    .content,
                  lock: data.lockStatus,
                },
              },
            },
          },
        };
        newComponent = coverpage;
      }
    } else if (data.isHeaderView) {
      let headerComponent = null;
      if (components[data.headerComponentID]) {
        headerComponent = { ...components[data.headerComponentID] };
      }
      if (headerComponent) {
        headerComponent = {
          ...headerComponent.content,
          data: {
            ...headerComponent.content.data,
            header: {
              ...headerComponent.content.data.header,
              components: {
                ...headerComponent.content.data.header.components,
                [data.activeComponentID]: {
                  ...headerComponent.content.data.header.components[
                    data.activeComponentID
                  ],
                  content: {
                    ...headerComponent.content.data.header.components[
                      data.activeComponentID
                    ].content,
                    lock: data.lockStatus,
                  },
                },
              },
            },
          },
        };
        newComponent = headerComponent;
      }
    } else if (data.isFooterView) {
      let footerComponent = null;
      if (components[data.footerComponentID]) {
        footerComponent = { ...components[data.footerComponentID] };
      }
      if (footerComponent) {
        footerComponent = {
          ...footerComponent.content,
          data: {
            ...footerComponent.content.data,
            footer: {
              ...footerComponent.content.data.footer,
              components: {
                ...footerComponent.content.data.footer.components,
                [data.activeComponentID]: {
                  ...footerComponent.content.data.footer.components[
                    data.activeComponentID
                  ],
                  content: {
                    ...footerComponent.content.data.footer.components[
                      data.activeComponentID
                    ].content,
                    lock: data.lockStatus,
                  },
                },
              },
            },
          },
        };
        newComponent = footerComponent;
      }
    }
  }
  dispatch({
    type: "TOGGLE_COMPONENT_LOCK_UNLOCK",
    payload: {
      component: newComponent,
      activeComponentID: data.activeComponentID,
      activeComponentType: data.activeComponentType,
    },
  });
  setTimeout(() => {
    updateSection(DOCUMENT_MODE.TEMPLATE)(newComponent)
      .then(() => {})
      .catch(error => {
        console.error("error", error);
        if (data.oldSection) {
          dispatch({
            type: "TOGGLE_COMPONENT_LOCK_UNLOCK",
            payload: {
              component: data.oldSection,
              activeComponentID: data.activeComponentID,
              activeComponentType: data.activeComponentType,
            },
          });
        }
      });
  }, 500);

  // Nuke the Editor State
  const { EditorStore } = store.getState();
  const { clickedEditorState, clickedSection } = EditorStore;
  if (clickedSection || clickedEditorState) {
    dispatch({ type: "NUKE_EDITOR_STATE" });
  }
};

export const removeComponentInDocument = sectionID => dispatch => {
  const { components } = store.getState().DocumentStore;
  const { dealTableId } = store.getState().QuotationStore;
  let isDealtableComponent = false;
  let isGoogleSheetComponent = false;
  const component = components[sectionID] && components[sectionID].content;
  if (
    component.type === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE ||
    component.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE
  ) {
    isDealtableComponent = true;
  } else if (component.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
    isGoogleSheetComponent = true;
  }
  if (isDealtableComponent && dealTableId)
    store.dispatch(removeQuotetableData());
  if (isGoogleSheetComponent) store.dispatch(removeGoogleSheetData(sectionID));
  dispatch({
    type: "REMOVE_COMPONENT_IN_DOCUMENT",
    payload: sectionID,
  });
};

// export const updateDocumentSectionLabel = (sectionID, label) => dispatch => {
//   dispatch({
//     type: "UPDATE_DOCUMENT_SECTION_LABEL",
//     payload: {
//       sectionID,
//       label,
//     },
//   });
// };

export const updateOutlineLabel = (
  newSection,
  mode,
  oldSection,
) => dispatch => {
  dispatch({
    type: "UPDATE_OUTLINE_LABEL",
    payload: { component: newSection },
  });
  updateSection(mode)(newSection)
    .then(() => {})
    // to handle fallback case
    .catch(error => {
      console.error("Error", error);
      dispatch({
        type: "UPDATE_OUTLINE_LABEL",
        payload: { component: oldSection },
      });
    });
};

export const reOrderDocumentSectionList = sectionList => dispatch => {
  dispatch({
    type: "REORDER_DOCUMENT_SECTIONLIST",
    payload: {
      sectionList,
    },
  });
};

export const deleteDocSignerSection = (
  signerData,
  docId,
  updatedSignerData,
) => dispatch =>
  new Promise((resolve, reject) => {
    deleteDocSigner(signerData, docId)
      .then(() => {
        const state = store.getState().DocumentStore;
        const {
          document: { signatories },
        } = state;
        const updatedSignatories = JSON.parse(JSON.stringify(signatories));
        const { component_id: compId } = signerData[0];
        updatedSignatories.forEach(signer => {
          if (signer.component_id === compId) {
            signer.signers = updatedSignerData;
          }
        });

        dispatch({
          type: "UPDATE_DOC_SIGNATORIES",
          payload: { updatedSignatories },
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const updateDataForSignatureSection = (signerData, docId) => dispatch =>
  new Promise((resolve, reject) => {
    updateDocSignatories(signerData, docId)
      .then(res => {
        const state = store.getState().DocumentStore;
        const {
          document: { signatories },
        } = state;
        const updatedSignatories = JSON.parse(JSON.stringify(signatories));
        updatedSignatories.forEach(signer => {
          if (signer.component_id === res[0].component_id) {
            let found = false;
            signer.signers.forEach((d, index) => {
              if (d.id === res[0].signers[0].id) {
                signer.signers[index] = { ...res[0].signers[0] };
                found = true;
              }
            });
            if (!found) {
              signer.signers.push(res[0].signers[0]);
            }
          }
        });
        dispatch({
          type: "UPDATE_DOC_SIGNATORIES",
          payload: { updatedSignatories },
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const updateDataForStripePaymentSection = component => dispatch =>
  new Promise((resolve, reject) => {
    updateDocumentComponentService(component)
      .then(() => {
        dispatch({
          type: "UPDATE_DOCUMENT_COMPONENT",
          payload: { component },
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const updateDataForTemplateSignatureSection = component => dispatch =>
  new Promise((resolve, reject) => {
    updateTemplateComponentService(component)
      .then(() => {
        dispatch({
          type: "UPDATE_DOCUMENT_COMPONENT",
          payload: { component },
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const updateDataForTemplateStripePaymentSection = component => dispatch =>
  new Promise((resolve, reject) => {
    updateTemplateComponentService(component)
      .then(() => {
        dispatch({
          type: "UPDATE_DOCUMENT_COMPONENT",
          payload: { component },
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const updateDocumentSectionAction = component => dispatch =>
  new Promise((resolve, reject) => {
    updateDocumentComponentService(component)
      .then(() => {
        dispatch({
          type: "UPDATE_DOCUMENT_COMPONENT",
          payload: { component },
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const acceptRejectSectionChanges = (
  sectionID,
  entityID,
  accept,
  mode = "DOCUMENT",
) => () => {
  const state = store.getState().DocumentStore;
  const { components } = state;
  const section =
    components && components[sectionID] ? components[sectionID].content : null;
  if (section) {
    const updatedSection = removeEntityFromSection(
      section,
      entityID,
      accept,
      mode,
    );
    store.dispatch(updateDocumentSectionAction(updatedSection));
  }
};

export const updateUsedFormFields = updatedList => dispatch =>
  new Promise(resolve => {
    dispatch({
      type: "UPDATE_USED_FORM_FIELD",
      payload: updatedList,
    });
    resolve();
  });

// eslint-disable-next-line no-unused-vars
export const updateDynamicFieldsInDoc = (
  id,
  value,
  isShared,
  sharingHash,
  fillerType,
  // eslint-disable-next-line no-unused-vars
) => dispatch =>
  new Promise(resolve => {
    if (id) {
      const reduxState = store.getState();
      const {
        components,
        document: {
          fields_used: fieldUsed,
          template_id: templateID,
          id: docId,
        },
      } = reduxState.DocumentStore;
      const { dealTableId } = reduxState.QuotationStore;
      const {
        priceBook: { [dealTableId]: priceBook = {} } = {},
      } = reduxState.DealTableStore;

      const updatedSection = [];

      const documentType = templateID
        ? DOCUMENT_MODE.TEMPLATE_DOCUMENT
        : DOCUMENT_MODE.DOCUMENT;
      const currency = priceBook ? priceBook.currency : DEFAULT_CURRENCY;
      if (!isShared) {
        updateDocumentField(docId, [
          { id, value, filler_type: fillerType },
        ]).then(response => {
          let updatedField = {};
          fieldUsed.forEach(field => {
            if (field.id === response.Fields[0].id) {
              field.value = response.Fields[0].value;
              field.filler_type = response.Fields[0].filler_type;
              updatedField = field;
            }
          });
          Object.keys(components).forEach(key => {
            if (
              Array.isArray(updatedField.occurrences) &&
              updatedField.occurrences.length > 0
            ) {
              updatedField.occurrences.forEach(df => {
                if (df.componentId === key)
                  updatedSection.push(components[key].content);
              });
            }
          });
          const updatedComponents = updatedSection.map(section => {
            const newComponent = getContentForComponent(section, documentType);
            const sectionID = section.section_id || section.id;
            newComponent.id = sectionID;
            newComponent.section_id = sectionID;
            newComponent.section_type =
              section.type || section.section.section_type;
            newComponent.section_name = section.header || section.section_name;
            newComponent.source = "DRAFT-JS";
            const updateComponentDetails = {
              content: newComponent,
              component_id: sectionID,
            };
            resolve();
            return updateComponentDetails;
          });

          const filledSection = [
            ...fillFormField(
              updatedComponents,
              documentType,
              fieldUsed,
              currency,
            ),
          ];
          const updatedSectionList = convertDocumentContent(
            filledSection,
            documentType,
          );
          store.dispatch(
            batchUpdateSectionInDocument(updatedSectionList.sections),
          );
          return updateUsedFormFields(fieldUsed);
        });
      }

      if (isShared) {
        updateDocumentFieldNonLoggedIn(docId, sharingHash, [
          { id, value, filler_type: fillerType },
        ]).then(response => {
          let updatedField = {};
          fieldUsed.forEach(field => {
            if (field.id === response.Fields[0].id) {
              field.value = response.Fields[0].value;
              field.filler_type = response.Fields[0].filler_type;
              updatedField = field;
            }
          });
          Object.keys(components).forEach(key => {
            if (
              Array.isArray(updatedField.occurrences) &&
              updatedField.occurrences.length > 0
            ) {
              updatedField.occurrences.forEach(df => {
                if (df.componentId === key)
                  updatedSection.push(components[key].content);
              });
            }
          });
          const updatedComponents = updatedSection.map(section => {
            const newComponent = getContentForComponent(section, documentType);
            const sectionID = section.section_id || section.id;
            newComponent.id = sectionID;
            newComponent.section_id = sectionID;
            newComponent.section_type =
              section.type || section.section.section_type;
            newComponent.section_name = section.header || section.section_name;
            newComponent.source = "DRAFT-JS";
            const updateComponentDetails = {
              content: newComponent,
              component_id: sectionID,
            };
            resolve();
            return updateComponentDetails;
          });

          const filledSection = [
            ...fillFormField(
              updatedComponents,
              documentType,
              fieldUsed,
              currency,
            ),
          ];
          const updatedSectionList = convertDocumentContent(
            filledSection,
            documentType,
          );
          store.dispatch(
            batchUpdateSectionInDocument(updatedSectionList.sections),
          );
          return updateUsedFormFields(fieldUsed);
        });
      }
    }
  });

export const prepareDocForm = data => dispatch => {
  dispatch({
    type: "DOC_FORM",
    payload: data,
  });
};

export const changeDocFormValidFlag = () => dispatch => {
  const reduxState = store.getState();
  const { docForm, components } = reduxState.DocumentStore;
  const flag = components ? validateDocForm(docForm, components) : false;
  dispatch({
    type: "IS_DOC_FORM_VALID",
    payload: flag,
  });
};

export const updateFormRowDataField = (
  id,
  value,
  compositeFieldKeyName,
  // eslint-disable-next-line no-unused-vars
) => dispatch => {
  if (id) {
    const reduxState = store.getState();
    const { docForm } = reduxState.DocumentStore;
    const data = [...docForm];
    const fieldIndex = data.findIndex(item => item.id === id);
    const tempFieldObj = { ...data[fieldIndex] };
    if (compositeFieldKeyName) {
      const tempValue = {
        ...tempFieldObj.value,
        [compositeFieldKeyName]: value,
      };
      tempFieldObj.value = tempValue;
    } else {
      tempFieldObj.value = value;
    }
    data[fieldIndex] = tempFieldObj;
    store.dispatch(prepareDocForm(data));
    store.dispatch(changeDocFormValidFlag());
  }
};

export const fetchDynamicFields = () => dispatch =>
  new Promise((resolve, reject) => {
    fetchDynamicFieldsService()
      .then(response => {
        dispatch({
          type: "ALL_DYNAMIC_FIELDS",
          payload: response.fields,
        });
        resolve("success");
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const editApprovedDocument = docID => () =>
  new Promise((resolve, reject) => {
    const state = store.getState().DocumentStore;
    const {
      content: { sections },
    } = state;
    const sectionsWithNoEmptyContainer = sections.filter(
      section => section.type !== "EmptyContainer",
    );
    const sectionList = createDocumentRevision(sectionsWithNoEmptyContainer);
    editApprovedDocumentService(docID, sectionList)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateClauseOptionsinDoc = (id, value) => dispatch => {
  const state = store.getState().DocumentStore;
  const { components, docForm } = state;
  const sec = Object.entries(components).find(
    section =>
      section[1].content.clauseOptions &&
      section[1].content.clauseOptions.id === id,
  );
  const clauseSection = sec && sec[1] && sec[1].content;
  if (clauseSection) {
    clauseSection.clauseOptions.value = value;
    updateDocumentComponentService(clauseSection)
      .then(() => {
        dispatch({
          type: "UPDATE_CLAUSE_OPTIONS_SECTION_IN_DOCUMENT",
          payload: {
            section: clauseSection,
            value,
            isDocFormValid: validateDocForm(docForm, {
              ...components,
              [clauseSection.id]: {
                ...components[clauseSection.id],
                content: clauseSection,
              },
            }),
          },
        });
      })
      .catch(error => {
        console.error("docActions =>", error);
      });
  }
};

export const sendForSignature = (esignId, esignType) => dispatch =>
  new Promise((resolve, reject) => {
    const signaturePayload = {
      esignId,
      esignType,
    };
    // const docStatusConfigs = generateDocStatusConfigs("SENT", "SENT");
    sendDocumentForSignature(signaturePayload)
      .then(response => {
        dispatch({
          type: "TOGGLE_IFRAME_VIEW",
          payload: {
            iframeUrl: "",
            envelopeID: "",
            // docStatusConfigs,
            status: "SENT",
            stage: "SENT",
            isSentForSignature: false,
          },
        });
        resolve(response);
      })
      .catch(error => {
        console.error("docActions =>", error);
        reject(error);
      });
  });

export const cancleESignature = docId => dispatch =>
  new Promise((resolve, reject) => {
    cancleESignatureService(docId)
      .then(response => {
        dispatch({
          type: "CANCLE_ESIGNATURE",
          payload: {
            stage: "DRAFT",
          },
        });
        resolve(response);
      })
      .catch(error => {
        console.error("DocumentActions => cancleESignature => Error ", error);
        reject(error);
      });
  });

export const docAcceptAndSignAction = (docId, sharinghash) => () =>
  new Promise((resolve, reject) => {
    docAccepAndSignService(docId, sharinghash)
      .then(response => {
        // dispatch({
        //   type: "DOC_ACCEPT_AND_SIGN",
        //   payload: {
        //     stage: "SENT",
        //   },
        // });
        resolve(response);
      })
      .catch(error => {
        console.error(
          "DocumentActions => docAcceptAndSignAction => Error ",
          error,
        );
        reject(error);
      });
  });

export const docAfterAccepAndSignAction = (docId, sharinghash) => () =>
  new Promise((resolve, reject) => {
    docAfterAccepAndSignService(docId, sharinghash)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(
          "DocumentActions => docAfterAccepAndSignAction => Error ",
          error,
        );
        reject(error);
      });
  });

// export const cancleESignature = docId => dispatch =>
// new Promise((resolve, reject) => {
//   const docStatusConfigs = generateDocStatusConfigs(
//     "APPROVED",
//     "Customer Review",
//   );
//   cancleESignatureService(docId)
//     .then(response => {
//       dispatch({
//         type: "CANCLE_ESIGNATURE",
//         payload: {
//           docStatusConfigs,
//           status: "APPROVED",
//           stage: "Customer Review",
//         },
//       });
//       resolve(response);
//     })
//     .catch(error => {
//       console.debug("docActions => cancleESignature", error);
//       reject(error);
//     });
// });

export const removeHighlightSelectionInDocument = sectionID => dispatch => {
  dispatch({
    type: "REMOVE_HIGHLIGHT_IN_DOCUMENT",
    payload: sectionID,
  });
};

export const updateSelectedDocCategory = docCategory => dispatch => {
  dispatch({
    type: "SELECTED_DOC_CATEGORY",
    payload: docCategory,
  });
};

export const updateDocDetails = payload => dispatch =>
  new Promise((resolve, reject) => {
    updateDocDetailsService(payload)
      .then(response => {
        dispatch({
          type: "PATCH_DOCUMENT_DETAILS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const updateDocMeta = payload => dispatch =>
  new Promise((resolve, reject) => {
    updateDocDetailsService(payload)
      .then(response => {
        dispatch({
          type: "UPDATE_DOCUMENT_META",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.debug("docActions => updateDocMeta", error);
        reject(error);
      });
  });

export const tempShowIframeDocSign = (iframeUrl, envelopeID) => dispatch => {
  dispatch({
    type: "TEMP_TOGGLE_IFRAME_VIEW",
    payload: {
      iframeUrl,
      envelopeID,
      stage: "APPROVED",
      isLocked: true,
      isSentForSignature: true,
    },
  });
};

export const showIframeDocSign = (iframeUrl, envelopeID) => dispatch => {
  const docStatusConfigs = generateDocStatusConfigs(
    "PREPARE_FOR_SIGNATURE",
    "Customer Review",
  );
  dispatch({
    type: "TOGGLE_IFRAME_VIEW",
    payload: {
      iframeUrl,
      envelopeID,
      docStatusConfigs,
      status: "PREPARE_FOR_SIGNATURE",
      stage: "Customer Review",
      isSentForSignature: true,
    },
  });
};

export const pricebookChangeUpdateDynamicFieldsInDoc = currency => () => {
  const reduxState = store.getState();
  const {
    components: docComponents,
    docForm: fieldUsed,
  } = reduxState.DocumentStore;
  const updatedSections = [];

  // Get all the form fields of type "AMOUNT"
  const amountFormFields = fieldUsed.filter(
    formField => formField.type === "AMOUNT",
  );

  // Update the "textValue" of "form_field" of those sections
  // which "form_field" is type of "AMOUNT"
  if (amountFormFields.length > 0) {
    amountFormFields.forEach(amountFormField => {
      Object.keys(docComponents).forEach(componentId => {
        const section = docComponents[componentId].content;
        let updateThisSectionFlag = false;
        if (
          Object.prototype.hasOwnProperty.call(section, "form_field") &&
          section.form_field
        ) {
          section.form_field.forEach((sectionFormField, index) => {
            if (sectionFormField.dynamicFieldId === amountFormField.id) {
              const { value } = amountFormField;
              const newField = {
                ...sectionFormField,
                value,
              };
              updateThisSectionFlag = true;
              let combinedValue = "";
              if (value !== "") {
                combinedValue = numberForamting(
                  value,
                  CURRENCY_SYMBOL[currency],
                );
              }
              newField.textValue = combinedValue;
              section.form_field[index] = newField;
            }
          });
        }
        if (updateThisSectionFlag) {
          updatedSections.push(section);
        }
      });
    });
  }

  if (updatedSections.length > 0) {
    const fields = amountFormFields.map(amountFormField => ({
      id: amountFormField.id,
      value: amountFormField.value,
    }));
    const documentType = DOCUMENT_MODE.DOCUMENT;

    // make the secton in a correct format to upddate the currency field in "html"
    const updatedComponents = updatedSections.map(section => {
      const newComponent = getContentForComponent(section, documentType);
      const sectionID = section.id || section.section_id;
      newComponent.section_id = sectionID;
      newComponent.section_type = section.type || section.section.section_type;
      newComponent.section_name = section.header || section.section_name;
      newComponent.source = "DRAFT-JS";
      const updateComponentDetails = {
        content: newComponent,
        component_id: sectionID,
      };
      return updateComponentDetails;
    });

    // Updating the sections with current currency
    const filledSection = fillFormField(
      updatedComponents,
      documentType,
      fieldUsed,
      currency,
    );
    const updatedSectionList = convertDocumentContent(
      filledSection,
      documentType,
    );

    batchUpdateDocumentSection(updatedSectionList.sections, fields).then(
      response => {
        // Pick necessary keys from API
        const { components } = response.Components;
        const newFilledSection = [
          ...fillFormField(components, documentType, fieldUsed, currency),
        ];
        const newUpdatedSectionList = convertDocumentContent(
          newFilledSection,
          documentType,
        );
        store.dispatch(
          batchUpdateSectionInDocument(newUpdatedSectionList.sections),
        );
      },
    );
  }
};

export const updateDraggedSection = (
  draggedSection,
  draggedFrom,
  draggedRowIndex,
  draggedColumnIndex,
) => dispatch => {
  dispatch({
    type: "UPDATE_DRAGGED_SECTION",
    payload: {
      draggedSection,
      draggedFrom,
      draggedRowIndex,
      draggedColumnIndex,
    },
  });
};

export const toggleDocumentDiffView = () => dispatch => {
  dispatch({
    type: "TOGGLE_DOCUMENT_DIFF_VIEW",
  });
};

// export const updateStyleComponentsDocumentSection = (
//   sectionType,
//   newSection,
// ) => dispatch => {
//   dispatch({
//     type: "UPDATE_STYLE_COMPONENTS_DOCUMENT_SECTION",
//     payload: { sectionType, newSection },
//   });
// };
// new document status and asset page
export const updateDocumentStatusAction = (docId, newStatus) => dispatch =>
  new Promise((resolve, reject) => {
    updateDocumentStatusService(docId, newStatus.id)
      .then(res => {
        batch(() => {
          dispatch({
            type: "UPDATE_DOCUMENT_STATUS",
            payload: newStatus,
          });
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateDocumentTagAction = (docId, newTag) => dispatch =>
  new Promise((resolve, reject) => {
    updateDocumentTagService(docId, newTag.id)
      .then(res => {
        dispatch({
          type: "UPDATE_DOCUMENT_TAG",
          payload: newTag,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateDocumentClickedComponentID = (id, flag, type) => dispatch =>
  dispatch({
    type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
    payload: {
      clickedActiveComponentId: id,
      preventClickedComponentIdUpdate: flag,
      clickedActiveComponentType: type,
    },
  });

export const deactivateComponentIfActive = id => dispatch =>
  dispatch({
    type: "DEACTIVATE_COMPONENT_IF_ACTIVE",
    payload: {
      clickedActiveComponentId: id,
    },
  });

export const preventEditorToDeactivate = flag => dispatch =>
  dispatch({
    type: "PREVENT_EDITOR_TO_DEACTIVATE",
    payload: flag,
  });

export const handleCustomColorDropDownOpen = (
  status,
  preventClickedComponentIdUpdate,
) => dispatch =>
  dispatch({
    type: "HANDLE_CUSTOM_COLOR_DROPDOWN_OPEN",
    payload: { status, preventClickedComponentIdUpdate },
  });

export const preventComponentToDeactivate = flag => dispatch =>
  dispatch({
    type: "PREVENT_COMPONENT_TO_DEACTIVATE",
    payload: flag,
  });

export const makeActiveEditor = (sectionID, flag) => dispatch =>
  dispatch({
    type: "MAKE_ACTIVE_EDITOR",
    payload: {
      sectionID,
      flag,
    },
  });

export const toggleCoverpageView = view => dispatch =>
  dispatch({ type: "TOGGLE_COVERPAGE_VIEW", payload: view });

export const deleteReviewersAction = (docID, reviewerID) => dispatch =>
  new Promise((resolve, reject) => {
    deleteReviewersServices(docID, reviewerID)
      .then(response => {
        dispatch({
          type: "REMOVE_REVIEWER",
          payload: {
            reviewerID,
          },
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const editReviewerPermissionAction = (
  docID,
  reviewerID,
  data,
) => dispatch =>
  new Promise((resolve, reject) => {
    editReviewerPermissionServices(docID, reviewerID, data)
      .then(response => {
        dispatch({
          type: "UPDATE_EDIT_PERMISSION_FOR_REVIEWER",
          payload: {
            reviewerID,
            data,
          },
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

// ADD DOCUMENT ACTIVITIES
export const addActivities = (
  objectId,
  before = null,
  after = null,
  limit = null,
  update = false,
) => dispatch =>
  new Promise((resolve, reject) =>
    getDocActivities(objectId, before, after, limit)
      .then(res => {
        let hasMore = false;
        if (
          res.headers &&
          res.headers.has_more &&
          res.headers.has_more === "true"
        ) {
          hasMore = true;
        }
        if (update) {
          dispatch({
            type: "UPDATE_DOCUMENT_ACTIVITIES",
            payload: {
              activities: res.data,
              hasMore,
            },
          });
        } else {
          dispatch({
            type: "ADD_DOCUMENT_ACTIVITIES",
            payload: {
              activities: res.data,
              hasMore,
            },
          });
        }
        resolve(res);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const removeDocumentActivities = () => dispatch =>
  dispatch({
    type: "REMOVE_DOCUMENT_ACTIVITIES",
  });

export const acceptanceApprovalStatusCheck = (
  docID,
  sharingHash,
  status,
  attachmentId,
) => dispatch =>
  new Promise((resolve, reject) =>
    acceptanceApprovalStatusCheckService(
      docID,
      sharingHash,
      status,
      attachmentId,
    )
      .then(res => {
        dispatch({
          type: "UPDATE_ACCEPTANCE_STATUS",
          payload: res,
        });
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

// UNDO/REDO STACK ACTIONS
export const reactionsOnUndoClick = () => dispatch => {
  const { DocumentStore, ToolPaneStore } = store.getState();
  const {
    stack: { undo, redo },
    clickedActiveComponentId,
    clickedActiveComponentType,
  } = DocumentStore;

  if (undo.length > 0) {
    const command = undo.shift();
    if (!command.unDoable) {
      // ignore if popped item is not a command
      return;
    }
    if (!command.preventNukeActiveState) {
      const { addComponentType } = ToolPaneStore;
      if (addComponentType) {
        // deactivate header footer before undo/redo
        dispatch({
          type: "UPDATE_ADD_COMPONENT_TYPE",
          payload: null,
        });
      }
      if (clickedActiveComponentId || clickedActiveComponentType) {
        dispatch({
          type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
          payload: {
            clickedActiveComponentId: null,
            preventClickedComponentIdUpdate: false,
            clickedActiveComponentType: null,
          },
        });
      }

      const { EditorStore } = store.getState();
      const { clickedEditorState, clickedSection } = EditorStore;
      if (clickedSection && clickedEditorState) {
        dispatch({ type: "NUKE_EDITOR_STATE" });
      }
    }

    command.undo();

    let redoStack = [redo];
    if (command.redoable) {
      redoStack =
        redo.length >= UNDO_REDO_STACK_LIMIT
          ? [command].concat(redo.slice(0, -1))
          : [command].concat(redo);
    }
    dispatch({
      type: "REACTION_ON_DOCUMENT_UNDO_ACTION",
      payload: {
        redoStack,
        undoStack: undo,
      },
    });
  } else {
    console.error("No more items to undo");
  }
};

export const reactionsOnRedoClick = () => dispatch => {
  const { DocumentStore, ToolPaneStore } = store.getState();
  const {
    stack: { undo, redo },
    clickedActiveComponentId,
    clickedActiveComponentType,
  } = DocumentStore;

  if (redo.length > 0) {
    const command = redo.shift();
    if (!command.unDoable || !command.redoable) {
      // ignore if popped item is not a command
      return;
    }

    if (!command.preventNukeActiveState) {
      const { addComponentType } = ToolPaneStore;
      if (addComponentType) {
        // deactivate header footer before undo/redo
        dispatch({
          type: "UPDATE_ADD_COMPONENT_TYPE",
          payload: null,
        });
      }
      if (clickedActiveComponentId || clickedActiveComponentType) {
        dispatch({
          type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
          payload: {
            clickedActiveComponentId: null,
            preventClickedComponentIdUpdate: false,
            clickedActiveComponentType: null,
          },
        });
      }

      const { EditorStore } = store.getState();
      const { clickedEditorState, clickedSection } = EditorStore;
      if (clickedSection && clickedEditorState) {
        dispatch({ type: "NUKE_EDITOR_STATE" });
      }
    }

    command.execute();

    const undoStack =
      undo.length >= UNDO_REDO_STACK_LIMIT
        ? [command].concat(undo.slice(0, -1))
        : [command].concat(undo);
    dispatch({
      type: "REACTION_ON_DOCUMENT_REDO_ACTION",
      payload: {
        redoStack: redo,
        undoStack,
      },
    });
  } else {
    console.error("No more items to redo");
  }
};

export const undoComponentUpdate = payload => dispatch => {
  dispatch({
    type: "UNDO_COMPONENT_UPDATE",
    payload,
  });
};

export const resetUndoRedoStack = () => dispatch => {
  dispatch({
    type: "RESET_UNDO_REDO_STACK",
  });
};

export const nukeDocument = () => dispatch => {
  dispatch({
    type: "NUKE_DOCUMENT",
  });
};

export const generatePermaLinkAction = payload => dispatch =>
  new Promise((resolve, reject) =>
    generatePermaLinkService(payload)
      .then(res => {
        dispatch({
          type: "GENERATE_PERMA_LINK",
          payload: res,
        });
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const generateSnapLinkAction = payload => dispatch =>
  new Promise((resolve, reject) =>
    generateSnapLinkService(payload)
      .then(res => {
        dispatch({
          type: "GENERATE_SNAP_LINK",
          payload: res,
        });
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getPermaLinkAction = (objectId, objectType) => dispatch =>
  new Promise((resolve, reject) =>
    getPermaLinkService(objectId, objectType)
      .then(res => {
        if (res.data !== null) {
          dispatch({
            type: "GET_PERMA_LINK",
            payload: res,
          });
        }
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getSnapLinkAction = (objectId, objectType) => dispatch =>
  new Promise((resolve, reject) =>
    getSnapLinkService(objectId, objectType)
      .then(res => {
        if (res.data !== null) {
          dispatch({
            type: "GET_SNAP_LINK",
            payload: res,
          });
        }
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const deletePermaLinkAction = (objectId, objectType) => dispatch =>
  new Promise((resolve, reject) =>
    deletePermaLinkService(objectId, objectType)
      .then(res => {
        dispatch({
          type: "DELETE_PERMA_LINK",
          payload: res,
        });
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const deleteSnapLinkAction = (objectId, objectType) => dispatch =>
  new Promise((resolve, reject) =>
    deleteSnapLinkService(objectId, objectType)
      .then(res => {
        dispatch({
          type: "DELETE_SNAP_LINK",
          payload: res,
        });
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

export const coverpageThemeAction = view => dispatch =>
  dispatch({ type: "COVERPAGE_THEME_ACTION", payload: view });

export const initSharedPermaSignedDocumentData = payload => dispatch => {
  dispatch({
    type: "INIT_SHARED_PERMA_DOCUMENT_DATA",
    payload,
  });
};

export const updateComponentMeta = componentMeta => dispatch => {
  dispatch({
    type: "UPDATE_COMPONENT_META_IN_TOOLBAR",
    payload: componentMeta,
  });
};

export const updateSubmitRejectSignerFillerAction = (
  docID,
  sharingHash,
  view,
  data,
) => dispatch =>
  new Promise((resolve, reject) => {
    updateSubmitRejectSignerFiller(docID, sharingHash, view, data)
      .then(res => {
        const payload = res;
        payload.recipientType = "SIGNER";
        if (!res.doc_stage) {
          if (view === "submit") {
            payload.doc_stage = "SENT";
          } else {
            payload.doc_stage = "DECLINED";
          }
        }
        dispatch({
          type: "UPDATE_ACCEPTANCE_STATUS",
          payload,
        });
        dispatch({
          type: "UPDATE_DOCUMENT_RECIPIENT",
          payload,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateDocSignatoriesAction = updatedSignatories => dispatch =>
  dispatch({
    type: "UPDATE_DOC_SIGNATORIES",
    payload: { updatedSignatories },
  });

export const updateStatusFormField = docForm => dispatch => {
  dispatch({
    type: "UPDATE_STATUS_FORM_FIELD",
    payload: docForm,
  });
};
export const updateSubmitDeclineInternalAction = (
  docId,
  type,
  userId,
  data,
) => dispatch =>
  new Promise((resolve, reject) => {
    updateSubmitDeclineInternalService(docId, type, data)
      .then(res => {
        const payload = res;
        payload.recipientType = "SIGNER";
        payload.user_id = userId;
        if (!res.doc_stage) {
          if (type === "submit") {
            payload.doc_stage = "SENT";
          } else {
            payload.doc_stage = "DECLINED";
          }
        }
        dispatch({
          type: "UPDATE_ACCEPTANCE_STATUS",
          payload,
        });
        dispatch({
          type: "UPDATE_DOCUMENT_RECIPIENT_INTERNAL",
          payload,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

// SUPPORT ADDITION OF BLOCKS INTO PDF DOCUMENT
export const addEsignBlockData = (docID, payload) => dispatch =>
  new Promise((resolve, reject) =>
    updateDocSignatories(payload, docID)
      .then(res => {
        const content = {
          header: "",
          id: res[0].component_id,
          label: `Signature ${res.length}`,
          lock: false,
          type: "Signature",
          data: res[0].signers,
        };
        batch(() => {
          dispatch({
            type: "REACTION_ON_ADDING_ESIGN_BLOCK",
            payload: {
              res,
              content,
            },
          });
          dispatch({
            type: "UPDATE_TOOLPANE_DATA_FOR_SIGNATURE",
            payload: {
              sectionData: content,
            },
          });
          dispatch({
            type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
            payload: {
              clickedActiveComponentId: res[0].component_id,
              preventClickedComponentIdUpdate: false,
              clickedActiveComponentType: "Signature",
            },
          });
        });
        resolve("success");
      })
      .catch(err => {
        reject(err);
      }),
  );

// SUPPORT REPOSITION OF BLOCKS INTO PDF DOCUMENT
export const updateAddEsignBlockData = payload => dispatch => {
  const res = payload;
  const content = {
    header: "",
    id: res[0].component_id,
    label: `Signature ${payload.length}`,
    lock: false,
    type: "Signature",
    data: res[0].signers,
  };
  batch(() => {
    dispatch({
      type: "REACTION_ON_ADDING_ESIGN_BLOCK",
      payload: {
        res,
        content,
      },
    });
    dispatch({
      type: "UPDATE_TOOLPANE_DATA_FOR_SIGNATURE",
      payload: {
        sectionData: content,
      },
    });
    dispatch({
      type: "UPDATE_DOCUMENT_CLICKED_COMPONENT_ID",
      payload: {
        clickedActiveComponentId: res[0].component_id,
        preventClickedComponentIdUpdate: false,
        clickedActiveComponentType: "Signature",
      },
    });
  });
};

export const stripeUserDetails = () => dispatch =>
  new Promise(resolve => {
    getStripeUser()
      .then(response => {
        if (response.StripeSubscriber.access_token) {
          console.debug(response);
          writeDataToLocalStorage("stripeData", response.StripeSubscriber);
          dispatch({
            type: "AUTH_STRIPE",
            payload: response.StripeSubscriber,
          });
        }
        resolve(response);
      })
      .catch(error => {
        if (error.response.status === 500) {
          dispatch({
            type: "STRIPE_AUTH_FLAG",
            payload: false,
          });
        }
      });
  });

export const getAuthStripe = config => dispatch =>
  new Promise((resolve, reject) => {
    console.debug("payload for authstrip is", config);
    authStripe(config)
      .then(response => {
        console.debug("response for authstrip is", response);
        writeDataToLocalStorage("stripeData", response.StripeSubscriber);
        dispatch({
          type: "AUTH_STRIPE",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getStripePaymentOnSave = payload => () =>
  new Promise((resolve, reject) => {
    sendStripePaymentOnSave(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug("docActions =>", error);
        reject(error);
      });
  });

export const generateStripeButtonSessionId = config => dispatch =>
  new Promise((resolve, reject) => {
    getStripePaymentSessionId(config)
      .then(response => {
        dispatch({
          type: "ADD_STRIPE_SESSION_ID",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllPaymentDetails = (docId, stripeID) => dispatch =>
  new Promise((resolve, reject) => {
    getStripePaymentDetails(docId, stripeID)
      .then(response => {
        let isPaid = null;
        if (
          response.StripePaymentDetails &&
          response.StripePaymentDetails.length
        ) {
          isPaid = response.StripePaymentDetails.find(
            elem => elem.payment_status === "paid",
          );
        }
        if (isPaid) {
          dispatch({
            type: "STRIPE_PAYMENT_UPDATE",
            payload: "Paid",
          });
        }
        dispatch({
          type: "STRIPE_BUTTON_DETAILS",
          payload: response.StripePaymentDetails,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllPaymentDetailsWithHash = (
  docId,
  userID,
  sharingHash,
) => dispatch =>
  new Promise((resolve, reject) => {
    getStripePaymentDetailsWithHash(docId, userID, sharingHash)
      .then(response => {
        let isPaid = null;
        if (
          response.StripePaymentDetails &&
          response.StripePaymentDetails.length
        ) {
          isPaid = response.StripePaymentDetails.find(
            elem => elem.payment_status === "paid",
          );
        }
        if (isPaid) {
          dispatch({
            type: "STRIPE_PAYMENT_UPDATE",
            payload: "Paid",
          });
        }
        dispatch({
          type: "STRIPE_BUTTON_DETAILS",
          payload: response.StripePaymentDetails,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deactivateStripeUser = stripeID => dispatch =>
  new Promise((resolve, reject) => {
    deactivateStripe(stripeID)
      .then(response => {
        removeDataFromLocalStorage("stripeData");
        dispatch({
          type: "DEACTIVATE_STRIPE_USER",
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllPaymentDetailsWithPermaHash = (
  docId,
  userID,
  sharingHash,
) => dispatch =>
  new Promise((resolve, reject) => {
    getStripePaymentDetailsWithHashPerma(docId, userID, sharingHash)
      .then(response => {
        let isPaid = null;
        if (
          response.StripePaymentDetails &&
          response.StripePaymentDetails.length
        ) {
          isPaid = response.StripePaymentDetails.find(
            elem => elem.payment_status === "paid",
          );
        }
        if (isPaid) {
          dispatch({
            type: "STRIPE_PAYMENT_UPDATE",
            payload: "Paid",
          });
        }
        dispatch({
          type: "STRIPE_BUTTON_DETAILS",
          payload: response.StripePaymentDetails,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const forceUpdateEditorSectionIdAction = sectionId => dispatch => {
  const { DocumentStore } = store.getState();
  if (DocumentStore.forceUpdateEditorSectionId !== sectionId) {
    dispatch({
      type: "FORCE_UPDATE_EDITOR_SECTION_ID",
      payload: sectionId,
    });
  }
};

export const removeDisabledStripeButtonfromDoc = (
  stripeData,
  docId,
) => dispatch =>
  new Promise((resolve, reject) => {
    deleteStripeFromDocument(stripeData, docId)
      .then(response => {
        stripeData.component_id.forEach(id => {
          dispatch({
            type: "DELETE_DOCUMENT_COMPONENT",
            payload: id,
          });
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const executeCommand = command => dispatch => {
  command.execute();
  if (command.unDoable) {
    dispatch({
      type: "ADD_TO_UNDO_STACK",
      payload: command,
    });
  }
};

// updates layout inside coverpage, header-footer, etc
export const updateLayoutInsideComponent = (
  componentID,
  layout,
  draggedTo,
) => dispatch => {
  dispatch({
    type: "UPDATE_LAYOUT_INSIDE_COMPONENT",
    payload: {
      componentID,
      layout,
      draggedTo,
    },
  });
};

export const updateSharedUsers = payload => dispatch => {
  const { sharedUsersSender } = payload;

  dispatch({
    type: "UPDATE_SHARED_USERS",
    payload: {
      sharedUsersSender,
    },
  });
};

export const updateEmailMessage = payload => dispatch => {
  const emailMessage = payload;
  dispatch({
    type: "UPDATE_EMAIL_MESSAGE",
    payload: {
      emailMessage,
    },
  });
};

export const updateVideoUrl = payload => dispatch => {
  const videoKycUrl = payload;
  dispatch({
    type: "UPDATE_VIDEO_URL",
    payload: {
      videoKycUrl,
    },
  });
};



// WEBPACK FOOTER //
// ./src/actions/DocumentActions/index.js